/**
 */

export const WS_ACTION_SEND_MESSAGE = 'sendMessage' as const

export interface SendMessageRequest {
  action: typeof WS_ACTION_SEND_MESSAGE
  content: string
  conversation_id: string | null
  agency_slug: string | null
}

export interface EngineEvent {
  kind: string
  event_id: string
  run_id: string
  tenant_id?: string
  parent_event_id?: string | null
  agent_execution_thread_id?: string | null
  agent_node_slug?: string | null
  ts: string
  data: Record<string, unknown>
}

export interface ConversationUpdatedEvent {
  type: 'conversation_updated'
  conversation_id: string
  conversation_name: string
  parent_event_id?: string
}

export type AppEvent = ConversationUpdatedEvent
